var _g, _path, _path2, _path3, _mask, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Save(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 173,
    viewBox: "0 0 237 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_8818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.956 43.8702L47.956 43.8701L117.203 3.89013C117.646 3.63455 118.148 3.5 118.659 3.5C119.17 3.5 119.672 3.63456 120.115 3.89012L189.362 43.8701L191.112 40.8391L189.362 43.8702C189.805 44.1257 190.172 44.4933 190.428 44.936C190.683 45.3786 190.818 45.8808 190.818 46.3919V126.352C190.818 126.863 190.683 127.365 190.428 127.808C190.172 128.251 189.805 128.618 189.362 128.874L191.112 131.905L189.362 128.874L120.115 168.854C119.672 169.109 119.17 169.244 118.659 169.244C118.148 169.244 117.646 169.109 117.203 168.854L47.956 128.874L46.2079 131.902L47.9559 128.874C47.5133 128.618 47.1457 128.251 46.8901 127.808C46.6345 127.365 46.5 126.863 46.5 126.352V46.3919C46.5 45.8808 46.6345 45.3787 46.8901 44.936C47.1457 44.4933 47.5133 44.1257 47.956 43.8702Z",
    fill: "white",
    stroke: "url(#paint0_linear_1606_8818)",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 117.745V55.2555C178 54.3759 177.769 53.5118 177.33 52.75C176.891 51.9882 176.26 51.3557 175.5 50.9159L121.5 19.6713C120.74 19.2315 119.878 19 119 19C118.122 19 117.26 19.2315 116.5 19.6713L62.5001 50.9159C61.74 51.3557 61.1088 51.9882 60.6699 52.75C60.231 53.5118 60 54.3759 60 55.2555V117.745C60 118.624 60.231 119.488 60.6699 120.25C61.1087 121.012 61.74 121.644 62.5001 122.084L116.5 153.329C117.26 153.768 118.122 154 119 154C119.878 154 120.74 153.768 121.5 153.329L175.5 122.084C176.26 121.644 176.891 121.012 177.33 120.25C177.769 119.488 178 118.624 178 117.745Z",
    fill: "url(#paint1_linear_1606_8818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.515 45C125.381 45 120.221 54.0674 119 54.0674C117.933 54.0674 112.984 45 104.485 45C96.2185 45 89.4688 51.8174 89.027 60.0724C88.7779 64.7357 90.2809 68.2841 92.3996 71.4989C96.6315 77.9214 115.136 93.3813 119.027 93.3813C123.003 93.3813 141.34 77.9769 145.6 71.4991C147.724 68.2699 149.222 64.7358 148.973 60.0726C148.531 51.8174 141.782 45 133.515 45Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 162H0L10 138L0 112H47V162Z",
    fill: "url(#paint2_linear_1606_8818)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 114H237L227 138L237 164H190V114Z",
    fill: "url(#paint3_linear_1606_8818)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216 104H28V154H216V104Z",
    fill: "url(#paint4_linear_1606_8818)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-1_1606_8818",
    maskUnits: "userSpaceOnUse",
    x: 64.9609,
    y: 117.98,
    width: 114,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 64.9609,
    y: 117.98,
    width: 114,
    height: 22
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1606_8818",
    x1: 72,
    y1: 32,
    x2: 118.659,
    y2: 172.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#EFA461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#EC9D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F9B575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#FFDFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#FFFBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#E8C588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#E6AE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8D51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1606_8818",
    x1: 84,
    y1: 39,
    x2: 171.5,
    y2: 169.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EB9C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F9B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FFD5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FEEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F9E2B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC944E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1606_8818",
    x1: 9.55932,
    y1: 119.407,
    x2: 41.0143,
    y2: 169.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EB9C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F9B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FFD5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FEEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F9E2B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC944E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1606_8818",
    x1: 199.559,
    y1: 121.407,
    x2: 231.014,
    y2: 171.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EB9C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F9B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FFD5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FEEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F9E2B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC944E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1606_8818",
    x1: 66.2373,
    y1: 111.407,
    x2: 76.8988,
    y2: 179.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EB9C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F9B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FFD5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FEEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F9E2B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC944E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_8818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151.318,
    height: 172.743,
    fill: "white",
    transform: "translate(43)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Save);
export default __webpack_public_path__ + "static/media/3Save.22877f59.svg";
export { ForwardRef as ReactComponent };